function initCraftsmanshipSection() {
  const sections = document.querySelectorAll('.craftsmanship-section');

  sections.forEach(section => {
    const steps = section.querySelectorAll('.craftsmanship-step-block');
    const images = section.querySelectorAll('.craftsmanship-image');

    // Only run on desktop where the sticky layout exists
    if (window.innerWidth > 990 && steps.length > 0) {

      function checkScroll() {
        let closestStep = null;
        let minDistance = Infinity;
        const viewportCenter = window.innerHeight / 2;

        // Exactly calculate which step is closest to the middle of the screen
        steps.forEach(step => {
          const rect = step.getBoundingClientRect();
          const stepCenter = rect.top + rect.height / 2;
          const distance = Math.abs(stepCenter - viewportCenter);

             if (distance < minDistance) {
            minDistance = distance;
            closestStep = step;
          }
        });
       // Only update if a new step is closest
        if (closestStep && !closestStep.classList.contains('is-active')) {
          const stepIndex = closestStep.getAttribute('data-step');
          steps.forEach(s => s.classList.remove('is-active'));
          closestStep.classList.add('is-active');
          images.forEach(img => {
            if (img.getAttribute('data-step') === stepIndex) {
              img.classList.add('is-active');
            } else {
              img.classList.remove('is-active');
            }
          });
        }
      }
      // Run on load
      checkScroll();
      // Catch scroll events from ANY container (fixes issues with custom Shopify themes)
      document.addEventListener('scroll', checkScroll, { capture: true, passive: true });
    }
  });
}

// Run when the main website loads
document.addEventListener("DOMContentLoaded", initCraftsmanshipSection);

// Run when editing inside the Shopify Theme Editor
document.addEventListener("shopify:section:load", initCraftsmanshipSection);